import styled from "styled-components";

export const MasterVolumeContainer = styled.div`
  display: inline-flex;

  .ant-popover-inner-content {
    padding: 0;
  }
`;
